<template>
    <div id="app" style="height: 100%;">
      <app-login v-if="$route.meta.needLogin"></app-login>
      <app-un-login v-else></app-un-login>
    </div>
</template>

<script>

import '@/assets/css/base.less'
import AppLogin from '@/AppLogin'
import AppUnLogin from '@/AppUnLogin'
import store from '@/store/store'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppLogin,
    AppUnLogin
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      getSelectMonth: 'getSelectMonth'
    })
  },
  methods: {

  },
  created () {
    store.commit('set_range_time', this.getSelectMonth)
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue